var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var DownArrow = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("rect", { x: "0", y: "0", fill: "none", width: "24", height: "24" }),
        React.createElement("path", { fill: "#3D3D36", transform: "translate(6.000000, 5.000000)", d: "M6,9.5c-0.1,0-0.3,0-0.4-0.1l-4-4c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0L6,8.3l3.6-3.6\n          c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-4,4C6.3,9.5,6.1,9.5,6,9.5z" })));
};
export default DownArrow;
